// Lead Source 2.1, updated 7/31/19
(function ($) {
	var cookie = require('js-cookie');

	function getStoredReferrer() {
		return cookie.get('visitorsOriginalReferrer');
	}

	function setReferrer(referrer) {
		cookie.set('visitorsOriginalReferrer', referrer, {expires: 1, path: '/'});
	}

	function executeReferralCode(domain) {
		var referrer = getStoredReferrer();

		if (!referrer && document.referrer) {
			referrer = document.referrer;
			setReferrer(referrer);
		}

		if (!referrer) {
			// No stored referrer cookie and document.referrer is empty
			return;
		}

		var $referringUrlInput = $('input[value="topfloorHiddenFieldReferringURL"]'); // You will need to create a hidden input with this value in your Gravity Form
		var $leadSourceInput = $('input[value="topfloorHiddenFieldLeadSource"]'); // You will need to create a hidden input with this value in your Gravity Form

		if ($referringUrlInput.length) {
			console.log('setting referral to: ' + referrer);
			$referringUrlInput.val(referrer);
		}

		if ($leadSourceInput.length) {
			if (referrer.match(/(&adurl|&gclid)/)) {
				leadSource = "Paid Google Ad";
			} else if (referrer.match(domain)) {
				leadSource = "Web Direct";
			} else if (referrer.match(/(ask|bing|msn\.com|yahoo|google)/)) {
				leadSource = "Search - Organic";
			} else if (referrer.match(/(twitter\.com|t\.co|facebook\.com|fb\.com|linkedin\.com|flickr\.com|vimeo\.com|xing\.com|instagram\.com|foursquare\.com|fb\.me|plus\.google\.com|youtube\.com|youtu\.be|reddit\.com|tumblr\.com)/)) {
				leadSource = "Social";
			} else {
				leadSource = "Unknown";
			}

			console.log(leadSource);
			$leadSourceInput.val(leadSource);
		}
	}

	$(function () {
		executeReferralCode(window.location.hostname);
	});
})(jQuery);
